import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import BottomNav from './components/BottomNav'
import AuthGuard from './components/AuthGuard'
import ErrorBoundary from './components/ErrorBoundary'
import { usePageView } from './hooks/usePageView'
import BibleReaderPanel from './components/BibleReaderPanel'
import Toast from './components/Toast'
import OfflineIndicator from './components/OfflineIndicator'
import UpdatePrompt from './components/UpdatePrompt'
import Login from './pages/Login'
import Research from './pages/Research'
import Conversation from './pages/Conversation'
import Settings from './pages/Settings'
import Trash from './pages/Trash'
import CreatorStudio from './pages/CreatorStudio'
import CollectionDetail from './pages/CollectionDetail'
import DraftView from './pages/DraftView'
import AdminDashboard from './pages/AdminDashboard'
import Bible from './pages/Bible'

const TOP_LEVEL_PATHS = ['/research', '/bible', '/creator', '/settings', '/trash', '/admin-dashboard']

function AuthenticatedApp() {
  const location = useLocation()
  const showBottomNav = TOP_LEVEL_PATHS.includes(location.pathname)
  usePageView()

  return (
    <AuthGuard>
      <Layout>
        <main className="flex-1 min-h-0">
          <Routes>
            <Route path="/research" element={<Research />} />
            <Route path="/research/:threadId" element={<Conversation />} />
            <Route path="/bible" element={<Bible />} />
            <Route path="/creator" element={<CreatorStudio />} />
            <Route path="/creator/:collectionId" element={<CollectionDetail />} />
            <Route path="/creator/:collectionId/draft" element={<DraftView />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/trash" element={<Trash />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/research" replace />} />
          </Routes>
        </main>
        {showBottomNav && <BottomNav />}
        <BibleReaderPanel />
        <Toast />
        <OfflineIndicator />
        <UpdatePrompt />
      </Layout>
    </AuthGuard>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<AuthenticatedApp />} />
      </Routes>
    </ErrorBoundary>
  )
}
